import { api } from '@/shared/api/client';
import type { Schema } from '@/shared/api/contract';

/**
 * The one call about a quote that more than one feature needs.
 *
 * The quote editor owns the quote screens (`features/quotes`); the inbox needs to redo a
 * quote from the email that produced it when that quote was cancelled (contract v10.7).
 * A feature never imports another feature, so what both need lives here, and the
 * editor's `quoteKeys.detail` / `quoteKeys.lists` **are** these keys: one key each, so
 * an invalidation from either side reaches the other's cache entry.
 */
/** Every quote query: lists and details. A correction of what an email is can create or
 * cancel a quote (contract v10.24), and invalidating this reaches all of them. */
export const quotesRootKey = ['quotes'] as const;
export const quoteDetailKey = (id: string) => ['quotes', 'detail', id] as const;
export const quoteListsKey = ['quotes', 'list'] as const;

export const sharedQuotesApi = {
  /**
   * «Rehacer»: a new draft with the same lines, notes, supplier, customer and email as
   * a reviewed, sent or cancelled quote (`duplicated_from_id` says which). The original
   * is not touched. Idempotent on the back: a source with an open redo answers with it.
   */
  duplicate: (id: string): Promise<Schema<'QuoteRead'>> =>
    api.post<Schema<'QuoteRead'>>(`/api/quotes/${id}/duplicate`),
};
